
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnectorStraight as ObiConnectorStraightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connector-straight.js';
 
 
 

 
 export const ObiConnectorStraight = createComponent({
   react: React,
   tagName: 'obi-connector-straight',
   elementClass: ObiConnectorStraightElement,
   events: {
     
   }
  });
 
 